import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthenticationService} from '../shared/api/authentication/authentication.service';
import {UserService} from '../shared/api/resources/user/user.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted: boolean;
  events: any[] = [];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _fb: FormBuilder,
    private _authenticationService: AuthenticationService,
    private _userService: UserService) { }

  ngOnInit() {
    this.loginForm = this._fb.group({
      email: ['', [<any>Validators.required, <any>Validators.email]],
      password: ['', [<any>Validators.required]]
    });
  }

  login() {
    this.submitted = true;
    if (this.loginForm.valid) {
      this._authenticationService.login(this.loginForm.value.email, this.loginForm.value.password).subscribe(
        (authRes) =>  {
          this._authenticationService.loadFromWSResponse(authRes);
          this._userService.getUserDetails().subscribe(
            (userRes) => {
              this._userService.loadFromWSResponse(userRes);
              this._router.navigate(['../'], { relativeTo: this._route });
            }
          );
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts